import React from "react";
import { TextField, Paper, List, ListItem, ListItemText } from "@mui/material";

export default function SearchBox({ onPlaceSelected }) {
  const [inputValue, setInputValue] = React.useState("");
  const [suggestions, setSuggestions] = React.useState([]);
  const autocompleteServiceRef = React.useRef(null);
  const placesServiceRef = React.useRef(null);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      //console.error("❌ Google Maps not loaded or missing 'places' library.");
      return;
    }

    autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
    placesServiceRef.current = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    //console.log("✅ Google Maps services initialized");
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
      return;
    }

    if (autocompleteServiceRef.current) {
      autocompleteServiceRef.current.getPlacePredictions(
        { input: value },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            Array.isArray(predictions)
          ) {
            setSuggestions(predictions);
            //console.log("🔍 Predictions:", predictions);
          } else {
            setSuggestions([]);
            //console.warn("⚠️ Autocomplete status:", status);
          }
        }
      );
    }
  };

  const handleSuggestionClick = (placeId) => {
    //console.log("📍 Fetching details for:", placeId);
    if (placesServiceRef.current && placeId) {
      placesServiceRef.current.getDetails(
        { placeId, fields: ["geometry", "name", "formatted_address"] },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const lat = place.geometry?.location?.lat();
            const lng = place.geometry?.location?.lng();
            const name = place.name || place.formatted_address || inputValue;

            if (typeof lat === "number" && typeof lng === "number") {
              //console.log("✅ Selected:", { lat, lng, name });
              onPlaceSelected({ lat, lng, name });
              setSuggestions([]);
              setInputValue(name);
            } else {
              //console.warn("⚠️ Invalid lat/lng from place:", place);
            }
          } else {
            //console.warn("❌ Failed to get place details:", status);
          }
        }
      );
    }
  };

  return (
    <div
      ref={containerRef}
      style={{ position: "absolute", top: 10, left: 10, zIndex: 999 }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search location..."
        value={inputValue}
        onChange={handleInputChange}
        style={{ width: "300px", background: "white" }}
      />
      {suggestions.length > 0 && (
        <Paper elevation={3} style={{ position: "absolute", width: "100%" }}>
          <List>
            {suggestions.map((suggestion) => (
              <ListItem
                button
                key={suggestion.place_id}
                onClick={() => handleSuggestionClick(suggestion.place_id)}
              >
                <ListItemText primary={suggestion.description} />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </div>
  );
}
